import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=11879dfe&scoped=true"
import script from "./SummaryItem.vue?vue&type=script&lang=js"
export * from "./SummaryItem.vue?vue&type=script&lang=js"
import style0 from "./SummaryItem.vue?vue&type=style&index=0&id=11879dfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11879dfe",
  null
  
)

export default component.exports